<div>
	<div class="dwform" style="padding-right: 15px;height: 100%;min-width: 300px !important;width: 400px !important;margin-top: 15px;">
		   <div class="dwform-cell-nopadding"
			   style="min-width:300px;width: 100%;padding-left: 20px;"> 
				
				<div class="dwform-row">
			   <label class="label-field" style="width: 180px;">Date Submitted / Requested:</label><span class="form-required"></span>
	           <span class="form-required">*</span>
	           <input class="input-field-short" style="width:80px;"
	                  mask="9999-99-99" [dropSpecialCharacters]="false"
	                  showMaskTyped="true"
	                  id="datesubmittedid"
	                  [(ngModel)]="dateSubmitted" [disabled]="!enableRequestedSubmittedDate"
	                  placeholder="<submit date>" type="text"/>
				</div>
	
	           <div class="dwform-row-gap"></div>
	           <label class="label-field" style="margin-right: 8px;width: 180px;">Date Closed / Completed:</label>
	           <span class="form-required">*</span>
	
	           <input class="input-field-short" style="width:80px;"
	                  mask="9999-99-99" [dropSpecialCharacters]="false"
	                  showMaskTyped="true"
	                  id="dateclosedid"
	                  [(ngModel)]="dateClosed" [disabled]="!enableCompletedClosedDate"
	                  placeholder="<closed date>" type="text"/>
	         <div class="dwform-row-gap"></div>
				        
				<label class="label-field" style="width: 180px;">Suppress automatic E-mails:</label>
						<span class="form-required"></span>
						  <mat-checkbox [(ngModel)]="supressEmails" binary="true"  matTooltipPosition="below" style="margin-left:8px;"
	                            matTooltip="Keep this request open even if the time has lapsed and the due date is missed"></mat-checkbox>
			</div>
	
		<!----------------------->
		<!-- ERROR LINE --------->
		<!----------------------->
		<div class="error-line" [hidden]='!strErr.length'
			 style="text-align:left;bottom: 55px;">{{strErr}}</div>
		<!----------------------->
		<!-- SAVE STRIP        -->
		<!----------------------->
		<div class="save-close-strip" style="width: 97.5%; bottom: 16px;">
	
			<button mat-button class="command-button"
					(click)="submitRecord()" matTooltip="Save the record"
					mat-button>
				<mat-icon>check_circle_outline</mat-icon>
				Submit
			</button>
			<button mat-button class="command-button"
					(click)="cancelSubmitRecord()" matTooltip="Cancel edits" mat-button>
				<mat-icon>highlight_off</mat-icon>
				Cancel
			</button>
		</div>
	</div>
</div>
